﻿import { Component, Inject } from "@fiqas/angular-utils";
import { RootRouterComponent, RouteConfig } from "@fiqas/ngcomponentrouter";
import { Memoize } from "@fiqas/utils";
import * as Rx from "rxjs/Rx";
import { Subscription } from "rxjs/Subscription";
import { FIQAssist } from "../app";
import { SeqURL } from "../constants";
import { IDisposable } from "../interfaces/general";
import { CollectionResult } from "../interfaces/iFqs";
import { ParsedResult } from "../models/base";
import { GetCustomerResultItem } from "../models/customer";
import { CompactServiceCase } from "../models/serviceCase";
import { User } from "../models/user";
import { StartVersion } from "../models/version";
import { AuthenticationService } from "../services/authenticationService";
import { AuthorizationService } from "../services/authorizationService";
import { CacheService } from "../services/cache";
import { DialogService } from "../services/dialogService";
import { HomeService } from "../services/fiqassistApi/homeService";
import { ReportService } from "../services/fiqassistApi/reportService";
import { ServiceCaseService } from "../services/fiqassistApi/serviceCaseService";
import { UserService } from "../services/fiqassistApi/userService";
import { IsProcessingService } from "../services/isProcessingService";
import { LogService } from "../services/logService";
import { NgLogListener } from "../services/ngLogListener";
import { ServiceUtils } from "../services/serviceBase";
import { ServiceCaseSearchService } from "../services/serviceCaseSearchService";
import { SessionService } from "../services/session";
export interface ApplicationSettings {
    culture: string;
}

@Component({
    module: FIQAssist,
    selector: "application",
    templateUrl: "views/application.html"
})
@RootRouterComponent(FIQAssist, "application")
@RouteConfig([
    { path: '/home/...', name: "Home", component: "home" },

    { path: '/login', name: "Login", component: 'login' },
    { path: '/goodbye', name: "GoodBye", component: 'logout' },
    { path: '/changepassword', name: "ChangePassword", component: 'changePassword' },
    { path: '/forgotpassword', name: "ForgotPassword", component: 'forgotPassword' },
    { path: '/newpassword', name: "NewPassword", component: 'newPassword' },

    { path: '/request/...', name: "Request", component: 'requestBase' },
    { path: '/problem/...', name: "Problem", component: 'problemBase' },

    { path: '/complaint/...', name: "Complaint", component: 'complaintBase' },
    { path: '/compliment/...', name: "Compliment", component: 'complimentBase' },

    { path: '/reports', name: "Reports", component: 'reports' },
    { path: '/about', name: "About", component: 'about' },

    { path: '/other', name: "Other", component: "other" },

    { path: "/**", name: "Default", component: "home" } // default route, keep as last route in table due to routing bug..
])
export class Application {
    private subscriptions: Subscription[] = [];
    public entryCids?: Array<number>;

    constructor(
        @Inject('$uibModal') private $modal: angular.ui.bootstrap.IModalService,
        @Inject('$location') public $location: angular.ILocationService,
        @Inject() private serviceCaseService: ServiceCaseService,
        @Inject() private homeService: HomeService,
        @Inject() private reportService: ReportService,
        @Inject() public userService: UserService,
        @Inject() private authenticationService: AuthenticationService,
        @Inject() private authorizationService: AuthorizationService,
        @Inject() private sessionService: SessionService,
        @Inject() private isProcessingService: IsProcessingService,
        @Inject() private cacheService: CacheService,
        @Inject('$q') private $q: angular.IQService,
        @Inject('$rootRouter') public $rootRouter: angular.Router,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$scope') private $scope: ng.IScope,
        @Inject() private logService: LogService,
        @Inject() ngLogListener: NgLogListener,
        @Inject() private dialogService: DialogService,
        @Inject('$timeout') private $timeout: angular.ITimeoutService,
        @Inject('hotkeys') private hotkeys: ng.hotkeys.HotkeysProvider,
        @Inject('SeqURL') private seqUrl: SeqURL,
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject() private serviceCaseSearchService: ServiceCaseSearchService
    ) {
        var cids = this.$location.search().cid || [];
        this.entryCids = Array.isArray(cids) ? cids : [ cids ];

        logService.registerListner(ngLogListener);
        this.serviceCaseService.addUnauthorizedHandler((s, u) => this.loginSubject.next());
        this.homeService.addUnauthorizedHandler((s, u) => this.loginSubject.next());
        this.reportService.addUnauthorizedHandler((s, u) => this.loginSubject.next());
        this.userService.addUnauthorizedHandler((s, u) => this.loginSubject.next());

        this.authenticationService.addLogoutHandler(
            _ => {
                this.customers = null;
                this.user = null;
                this.cacheService.clear();
                this.sessionService.clear();
                this.$rootRouter.navigate(['Login']);
            }
        );
        this.authenticationService.addLoginHandler(
            () => {
                this.cacheService.clear();
            }
        );
        this.showMenu = !!this.authorizationService.currentRole;
        this.subscriptions.push(
            this.authorizationService.onRoleChanged(
                (roles) => {
                    this.showMenu = true;
                    this.user = null;
                    var _ = this.user;
                    this.customers = null;
                    this.selectedCustomers = [];
                    this.userService.Customers = null;
                    var __ = this.customers;

                    if (!roles.oldRole)
                        return;

                    var current = this.$location.url();
                    if (current.indexOf("/newpassword") >= 0
                        || current.indexOf("/forgotpassword") >= 0
                        || current.indexOf("/login") >= 0)
                        return;

                    var instruction = this.$rootRouter.generate(['Home']);
                    this.forceRedirect(instruction);
                }
            )
        );

        hotkeys.bindTo($scope);
        this.hotkey = [this.aboutHotkey = {
            combo: ['ctrl+alt+a'],
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: (e) => this.showAboutModal(e)
        }, {
            combo: ['ctrl+shift+f'],
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: (e) => this.focusFastSearch(e),
        }
        ];
        this.loginSubject = new Rx.Subject<void>();
        this.loginSubject.asObservable().throttleTime(100).subscribe(() => this.unauthorizedHandler());
        //this.$rootRouter.subscribe(r => this.enableFastSearch = r !== "home");
    }

    private hotkey: ng.hotkeys.Hotkey[];
    private aboutHotkey: ng.hotkeys.Hotkey;

    public Settings: ApplicationSettings = {
        culture: "nl"
    };

    public async $onInit() {
        this.cacheService.setValue<boolean>("navigated", false);
        this.cacheService.setValue<string>("navigated.firstUrl", this.$location.url());
        this._onFastSearchSubject = new Rx.Subject();
        this._onFastSearch = this._onFastSearchSubject.asObservable();

        this.$window.addEventListener("dragover", e => e.preventDefault(), false);
        this.$window.addEventListener("drop", e => e.preventDefault(), false);
        var _ = this.user;
        var __ = this.customers;
        this.showMenu = !!this.authorizationService.currentRole;
        this.hotkey.forEach(key => {
            this.hotkeys.add(key);
        });
    }

    public $onDestory() {
        this.subscriptions.forEach(sub => sub.unsubscribe);
        this.hotkey.forEach(key => {
            this.hotkeys.del(key.combo);
        });
    }
    private _searchPhrase: string;
    public get searchPhrase() {
        return this._searchPhrase;
    }
    public set searchPhrase(val: string) {
        this._searchPhrase = val;
    }
    public _showFastSearch: boolean;
    public get showFastSearch(): boolean {
        return this._showFastSearch;
    }
    public set showFastSearch(val: boolean) {
        var o = this._showFastSearch;
        this._showFastSearch = val;
        if (val != o && val) {
            this.$timeout(() => this.$element[0].parentElement.querySelector('.quicksearch-dropdown .texteditbox').focus());
        }
    }
    public get enableFastSearch(): boolean {
        return !this.serviceCaseSearchService.Searching;
    }

    private modalInstance: ng.ui.bootstrap.IModalServiceInstance
    public async showAboutModal($event) {
        this.hotkeys.del(this.aboutHotkey.combo);
        if ($event) {
            $event.preventDefault();
        }
        this.modalInstance = await this.dialogService.showAbout(this);
        this.modalInstance.result.finally(() => {
            this.hotkeys.add(this.aboutHotkey);
            this.modalInstance = null;
        });
    }

    public focusFastSearch($event) {
        if ($event) {
            $event.preventDefault();
        }
        if (this.enableFastSearch) {
            this.showFastSearch = !this.showFastSearch;
        }
    }

    public get onFastSearch(): Rx.Observable<[string, CollectionResult<CompactServiceCase>]> {
        return this._onFastSearch;
    }
    private _onFastSearch: Rx.Observable<[string, CollectionResult<CompactServiceCase>]>;
    private _onFastSearchSubject: Rx.Subject<[string, CollectionResult<CompactServiceCase>]>;

    public fastSearch(value) {
        if (value && value != "") {
            this.showFastSearch = false;
            this.simpleSearchMode = 5;
            this.simpleSearchString = value;
            this.isProcessingService.StartProcessing();
            this.searchPhrase = null;
            var sub = this.serviceCaseSearchService.Search(value, this.selectedCustomers.map(c => c.key), 100, 0)
                .subscribe({
                    next: result => {
                        if (result.count != 1) {
                            var i = this.$rootRouter.generate(["/Home/SimpleSearch"]);
                            this.$rootRouter.navigateByInstruction(i).then(_ => this._onFastSearchSubject.next([value, result]));
                        } else {
                            let parameters = { number: result.items[0].caseNumber };
                            this.$rootRouter.navigate([result.items[0].type == 'bug' ? 'Problem' : 'Request', 'Edit', parameters]);
                        }
                    },
                    error: error => {
                        if (ServiceUtils.IsUnauthorizedResponse(error)) {
                            return;
                        }
                        this.setSeqUrl(error);
                        this.logService.error('FastSearch', 'Error while searching', error);
                        this.dialogService.showErrorDialog('error', 'ERROR', 'SIMPLE_SEARCH_ERROR', { translate: true, errorResult: error });
                    },
                    complete: () => this.isProcessingService.StopProcessing()
                });
            sub.add(() => this.isProcessingService.StopProcessing());
        } else if (value == "") {
            this.showFastSearch = false;
        }
    }


    public get clientVersion(): string {
        return this.homeService.fiqassistClientVersion;
    }

    public get apiVersion(): StartVersion {
        return this.homeService.fiqassistApiVersion;
    }

    public recieveApiVersion(action: (value: StartVersion) => void): void {
        return this.homeService.recieveAPIVersion(action);
    }

    private forceRedirect = (instruction: ng.Instruction, tryNav = null) => {
        if (!tryNav) {
            tryNav = this.forceRedirect;
            this.forceRedirect = (newInstruction: ng.Instruction, newTryNav) => {
                if (instruction.urlPath().indexOf("/newpassword") < 0
                && instruction.urlPath().indexOf("/forgotpassword") < 0
                && instruction.urlPath().indexOf("/login") < 0) {
                    instruction = newInstruction;
                }
            };
        }
        if (this.$rootRouter.navigating) {
            this.isProcessingService.reset();
            this.$timeout(() => tryNav(instruction, tryNav), 50);
        } else {
            this.forceRedirect = tryNav;
            this.isProcessingService.reset();
            this.$rootRouter.navigateByInstruction(instruction);
        }
    }

    private loginSubject: Rx.Subject<void>;

    private unauthorizedHandler() {
        var current = this.$location.url();
        if (current.indexOf("/newpassword") >= 0
            || current.indexOf("/forgotpassword") >= 0
            || current.indexOf("/login") >= 0)
            return true;

        var target: any[] = ['Login'];
        if (current.indexOf("/login") == -1 && current.length > 1)
            target = target.concat({ source: encodeURIComponent(this.$location.url()) })


        var instruction = this.$rootRouter.generate(target);
        this.forceRedirect(instruction);
        return true;
    };

    private async getUser() {
        var user: User = null;
        try {
            try {
                if (!!this.authenticationService.username) {
                    user = await this.authorizationService.start(this.authenticationService.username);
                }
            } catch (error) {
                this.logService.error("Application", "Error retrieving logged in user record", error);
                this.loginSubject.next();
                this.personName = "";
                throw error;
            }
            try {
                if (user && user.personId.href) {
                    var person = await user.personId.value;
                    this.personName = person.name;
                }
            } catch (error) {
                this.logService.error("Application", "Error retrieving person record", error);
            }
        }
        finally {
            return user;
        }
    }
    public setSeqUrl(errorResult: ParsedResult) {
        if (this.authorizationService.isFiqasEmployee) errorResult.sequrl = this.seqUrl;
    }

    private orderByText(x: GetCustomerResultItem, y: GetCustomerResultItem): number {
        return x.name.toLowerCase() > y.name.toLowerCase() ? 1 : -1;
    }

    private _customers: { checked: boolean, key: string, text: string }[];
    private async getCustomers() {
        var lastSelectedCustomers = this.lastSelectedCustomers;
        try {
            var customers = await this.userService.Customers
            if (!customers || !customers.items || customers.items.length === 0) {
                return this._customers = [];
            }

            if (this.entryCids.length) {
                this._customers = customers.items
                    .sort(this.orderByText)
                    .map(c => { return { checked: this.entryCids.some(x => c.id.ref == x.toString()), key: c.id.ref, text: c.name } });
            }

            if (!this._customers) {
                var noSelectionPresent = (!this.lastSelectedCustomers || lastSelectedCustomers.length === 0);
                this._customers = customers.items
                    .sort(this.orderByText)
                    .map(c => { return { checked: noSelectionPresent || lastSelectedCustomers.some(x => c.id.ref == x.key), key: c.id.ref, text: c.name } });
            }

            this.selectedCustomers = this._customers.filter((cust) => cust.checked);
            // *1: don't skip the event trigger, when there no changes dedected, for initialization purposes (counter/recentcases in simplesearch)
            this.onaccountschanged(this.selectedCustomers, false /** *1 */);
        } catch (e) {
            this._customers = [];
        }
        finally {
            return this._customers;
        }
    }

    @Memoize()
    public get user() {
        var p = this.getUser();
        p.catch(() => this.user = null);
        return p;
    }
    public set user(_) { }

    @Memoize()
    public get customers() {
        var p = this.getCustomers();
        p.catch(() => this.customers = null);
        return p;
    }
    public set customers(_) {
        this._customers = null;
    }

    public personName: string;

    private _forcedCustomer: string = null;
    public get forcedCustomer(): string {
        return this._forcedCustomer;
    }
    public set forcedCustomer(customer: string) {
        this._forcedCustomer = customer;
    }

    public showMenu: boolean = false;

    public get showHeader() {
        return this.authenticationService.username &&
            this.$location.url().indexOf("/login") == -1 &&
            this.$location.url().indexOf("/newpassword") == -1 &&
            this.$location.url().indexOf("/goodbye") == -1 &&
            this.$location.url().indexOf("/forgotpassword") == -1;
    }

    private onAccountsChangedHandlers: ((selected: { key: any, text: string }[]) => void)[] = [];
    public addOnAccountsChanged(handler: (selected: { key: any, text: string }[]) => void): IDisposable {
        this.onAccountsChangedHandlers.push(handler)
        return () => {
            this.onAccountsChangedHandlers = this.onAccountsChangedHandlers.filter(h => h != handler);
        }
    }

    public selectedCustomers: { key: any, text: string }[] = [];

    public onaccountschanged(selected: { key: any, text: string }[], skipOnNoChange: boolean = true, automated: boolean = false): void {
        // Filter none have changed events, due to the bad preformance in some of it event handles (recentcases & counter queries by the simplesearch component).
        // Added skipOnNoChange argument due to initialization of other components.
        if (skipOnNoChange && this.areAccountsEqual(this.selectedCustomers, selected)) return;
        this.selectedCustomers = selected;
        this.lastSelectedCustomers = selected;
        if (!automated) {
            this.onAccountsChangedHandlers.forEach(h => h(selected));
        }
    }
    private areAccountsEqual(old: { key: any, text: string }[], current: { key: any, text: string }[]): boolean {
        if (old == null)
            return false;
        if (old.length != current.length)
            return false;
        return old.every(x => current.filter(y => x.key == y.key && x.text == y.text).length == 1);
    }
    public onaccountclicked(key: any, text: string): void {
        this.selectedCustomers = [{ key: key, text: text }];
    }

    private get lastSelectedCustomers(): { key: any }[] {
        var selected = this.sessionService.getValue<any[]>('selectedCustomers');
        if (selected == undefined)
            return [];
        return selected;
    }

    private set lastSelectedCustomers(val: { key: any }[]) {
        this.sessionService.setValue<any[]>('selectedCustomers', val, false, false);
    }

    public get simpleSearchMode(): number {
        var exp = this.sessionService.getValue<number>('simpleSearchMode');
        if (exp === undefined) return 1;
        return exp;
    }

    public set simpleSearchMode(exp: number) {
        this.sessionService.setValue<number>('simpleSearchMode', exp, false, false);
    }

    public get simpleSearchString(): string {
        var exp = this.sessionService.getValue<string>('simpleSearchString');
        if (exp === undefined) return "";
        return exp;
    }

    public set simpleSearchString(exp: string) {
        this.sessionService.setValue<string>('simpleSearchString', exp, false, false);
    }

    public get projectSearchMode(): number {
        var exp = this.sessionService.getValue<number>('projectSearchMode');
        if (exp === undefined) return 1;
        return exp;
    }

    public set projectSearchMode(exp: number) {
        this.sessionService.setValue<number>('projectSearchMode', exp, false, false);
    }

    public get projectSearchString(): string {
        var exp = this.sessionService.getValue<string>('projectSearchString');
        if (exp === undefined) return "";
        return exp;
    }

    public set projectSearchString(exp: string) {
        this.sessionService.setValue<string>('projectSearchString', exp, false, false);
    }

    public serviceDeskMode: boolean = false;
    public activeMenuItem: any = null;

    public go(location: string) {
        this.$rootRouter.navigateByUrl(location);
    }
}
